<template>
  <div>


    <!-- Pannello scommessa in accettazione / accettata / rifiutata -->
    <BetInAcceptanceInCart></BetInAcceptanceInCart>

    <!-- Empty state: solo senza odds, senza scommessa confermata e senza scommessa in accettazione -->
    <!-- Schedina vuota (mobile e desktop) -->
    <div class="empty-sheet" :class="{ 'empty-sheet--desktop': !cartSheet }" v-if="isEmpty">
      <div class="empty-sheet__art">
        <svg viewBox="0 0 120 96" width="132" height="106" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <g stroke="var(--color-primary-light)" stroke-width="3">
            <path d="M14 34l10 5M12 52h11M14 70l10-5"/>
            <path d="M106 34l-10 5M108 52H97M106 70l-10-5"/>
          </g>
          <g stroke="var(--text-op-50-platform)" stroke-width="3">
            <rect x="38" y="12" width="44" height="72" rx="6"/>
            <path d="M48 28h24M48 40h24M48 52h24M48 64h14"/>
          </g>
        </svg>
      </div>
      <span class="empty-sheet__title">{{ $t('cartSheet.emptyTitle') }}</span>
      <span class="empty-sheet__sub">{{ $t('cartSheet.emptySub') }}</span>

      <!-- Solo nella modale mobile: su desktop le partite sono già a fianco -->
      <button v-if="cartSheet" class="empty-sheet__cta" @click="browseMatches">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/>
        </svg>
        <span>{{ $t('cartSheet.browseMatches') }}</span>
      </button>

      <div class="empty-sheet__tip" v-if="maxBonusPercentage > 0">
        <svg class="empty-sheet__tip-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 18h6M10 21h4"/>
          <path d="M12 3a6 6 0 0 0-3.5 10.9c.6.4 1 1.1 1 1.9V16h5v-.2c0-.8.4-1.5 1-1.9A6 6 0 0 0 12 3z"/>
        </svg>
        <div class="empty-sheet__tip-body">
          <span class="empty-sheet__tip-title">{{ $t('cartSheet.tip') }}</span>
          <span class="empty-sheet__tip-text" v-html="$t('cartSheet.tipBonus', { pct: maxBonusPercentage })"></span>
        </div>
      </div>

      <!-- Freebet disponibili: invita l'utente a giocarle -->
      <FreeBetsPromo></FreeBetsPromo>
    </div>

    <!-- Contenuto normale betslip: nascosto quando la scommessa è confermata o in accettazione -->
    <div v-if="!getConfirmedBet && !hasAcceptanceBets && getBet.odds.length > 0">
      <BetTypeSelectorMarketView></BetTypeSelectorMarketView>
      <BetOddsSummaryMarketViewV3></BetOddsSummaryMarketViewV3>

      <v-progress-linear
          indeterminate
          color="var(--color-primary)"
          v-if="getLoading"
      ></v-progress-linear>

      <div v-if="getBet.type == 'single' || getBet.type == 'multiple'">
        <SummarySingleMultipleV3></SummarySingleMultipleV3>
      </div>
      <div v-else-if="getBet.type == 'integral'">
        <SummaryIntegralV3></SummaryIntegralV3>
      </div>
      <div v-else-if="getBet.type == 'system'">
        <SummarySystemV3></SummarySystemV3>
      </div>
    </div>

    <Errors></Errors>
    <Warnings></Warnings>

    <!-- Pannello riepilogo scommessa confermata -->
    <BetConfirmedMarketView></BetConfirmedMarketView>


  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import BetTypeSelectorMarketView from "@/components/right_widgets/BetTypeSelectorMarketView";
import BetOddsSummaryMarketViewV3 from "@/components/right_widgets/BetOddsSummaryMarketViewV3";
import SummarySingleMultipleV3 from "@/components/right_widgets/SummarySingleMultipleV3";
import SummaryIntegralV3 from "@/components/right_widgets/SummaryIntegralV3";
import SummarySystemV3 from "@/components/right_widgets/SummarySystemV3";
import ActionsMarketView from "@/components/right_widgets/ActionsMarketView";
import Errors from "@/components/right_widgets/Errors";
import Warnings from "@/components/right_widgets/Warnings";
import BetConfirmedMarketView from "@/components/right_widgets/BetConfirmedMarketView";
import BetInAcceptanceInCart from "@/components/right_widgets/BetInAcceptanceInCart";
import FreeBetsPromo from "@/components/right_widgets/FreeBetsPromo";

export default {
  name: 'BetSlip',
  inject: { cartSheet: { default: false } },
  components: {
    Warnings, SummarySingleMultipleV3, SummaryIntegralV3, SummarySystemV3,
    ActionsMarketView, Errors, BetOddsSummaryMarketViewV3, BetTypeSelectorMarketView,
    BetConfirmedMarketView, BetInAcceptanceInCart, FreeBetsPromo,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      'getLanguage':    'settings/getLanguage',
      'getBet':         'cart/getBet',
      'getSettings':    'cart/getSettings',
      'getLoading':     'cart/getLoading',
      'getMobileCartOpen': 'cart/getMobileCartOpen',
      'getConfirmedBet':            'cart/getConfirmedBet',
      'getAcceptingBets':           'cart/getAcceptingBets',
      'getAcceptedBetWithChange':   'cart/getAcceptedBetWithChange',
      'getBonusRules':              'cart/getBonusRules',
    }),

    isEmpty() {
      return this.getBet.odds.length == 0 && !this.getConfirmedBet && !this.hasAcceptanceBets;
    },

    maxBonusPercentage() {
      return (this.getBonusRules || []).reduce((max, rule) => Math.max(max, +rule.percentage || 0), 0);
    },

    // Hide the regular betslip while a bet is pending operator review or operator proposed a change
    hasAcceptanceBets() {
      return (this.getAcceptingBets || []).length > 0 || (this.getAcceptedBetWithChange || []).length > 0;
    },

  },
  methods: {
    ...mapActions({
      'setLoadingCart': 'cart/setLoadingCart',
      'refreshCart': 'cart/refreshCart',
      'initCartV2': 'cart/initCartV2',
      'setBetType': 'cart/setBetType',
      'setSystemComboDetail': 'cart/setSystemComboDetail',
    }),

    browseMatches() {
      this.$root.$emit('close_sidebar_right', true);
    },

  },
  async mounted() {
    this.getBet.system_parts = []
    this.getBet._system_detail.amount_system_to_divide = null
    this.getBet._system_detail.amount_system_equal = null
    this.getBet._system_detail.amount_system = 0.00
    this.getBet._system_detail.fixed_bases = []
    // await this.refreshCart()
    await this.initCartV2()
  },

};
</script>

<style scoped>
/* ── Empty state (bottom sheet mobile) ───────────────────── */
.empty-sheet {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 4px 8px;
  animation: fadeInUp 0.4s ease;
}

.empty-sheet__art {
  margin-bottom: 18px;
}

/* Sidebar desktop: stesso stato vuoto, un po' più compatto */
.empty-sheet--desktop {
  padding: 20px 4px 4px;
}

.empty-sheet--desktop .empty-sheet__art svg {
  width: 104px;
  height: 84px;
}

.empty-sheet--desktop .empty-sheet__tip {
  margin-top: 18px;
}

.empty-sheet__title {
  font-size: var(--font-size-6xl);
  font-weight: 700;
  color: var(--text-platform);
  margin-bottom: 8px;
}

.empty-sheet__sub {
  max-width: 260px;
  font-size: var(--font-size-2xl);
  line-height: 1.45;
  color: var(--text-op-50-platform);
}

.empty-sheet__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 42px;
  margin-top: 26px;
  border: none;
  border-radius: 12px;
  background: var(--btn-background);
  color: var(--btn-text);
  font-size: var(--font-size-3xl);
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.12s ease, filter 0.15s;
}

.empty-sheet__cta:active {
  transform: scale(0.98);
  filter: brightness(0.95);
}

.empty-sheet__tip {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 12px;
  background: var(--bg-card);
  border: 1px solid var(--border-color, rgba(255,255,255,0.06));
  text-align: left;
}

.empty-sheet__tip-icon {
  flex-shrink: 0;
  color: var(--color-primary-light);
}

.empty-sheet__tip-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.empty-sheet__tip-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--text-platform);
}

.empty-sheet__tip-text {
  font-size: var(--font-size-2xl);
  line-height: 1.45;
  color: var(--text-op-50-platform);
}

.empty-sheet__tip-text >>> u {
  color: var(--text-platform);
}


@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bsl-hint{
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}


.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-primary);
  box-shadow: 0 0 0 4px rgba(5, 149, 114, 0.15);
  animation: pulse 1.8s infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(5, 149, 114, 0.4); }
  50%       { box-shadow: 0 0 0 6px rgba(5, 149, 114, 0); }
}

</style>